import {CheckboxProps} from './types'
import CheckboxView from './CheckboxView'
import React from 'react'

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>((props, _ref): React.ReactElement => <CheckboxView {...props} ref={_ref} />)

Checkbox.displayName = 'Checkbox'

export default Checkbox
